module.exports = __webpack_public_path__ + "img/five_blue_stars.76b67646.png";